mutation DeleteQueueJobsMutation($queueName: String!, $ids: [ID]!) {
  deleteQueueJobs(queueName: $queueName, ids: $ids)
}
